<script setup lang="ts">
import { computed, useAttrs, useTemplateRef } from "vue";

import { injectStrict } from "@/utils/vue";

import InputField from "./InputField.vue";
import { labelInputKey } from "./injectKeys";

defineOptions({ inheritAttrs: false });
const props = defineProps<{ value: string; maxLength: number; suffix: string }>();
const emit = defineEmits<{ change: [string] }>();

const inputRef = useTemplateRef("input");

const labelInput = injectStrict(labelInputKey);
const attrs = useAttrs();
const unset = computed(() => !+props.value);
</script>

<template>
  <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions-->
  <div
    class="input-time action"
    :class="{ unset, error: !!labelInput.error.value }"
    @click="inputRef?.init()"
  >
    <InputField v-bind="attrs" ref="input" :value :max-length @change="emit('change', $event)" />
    <div aria-hidden="true">{{ suffix }}</div>
  </div>
</template>

<style lang="scss">
@use "@/styles/font";
@use "@/styles/variables";
@use "@/styles/variables/colors";

.input-time {
  background-color: colors.$background-ui;
  display: flex;
  justify-content: center;
  flex: 1;
  align-items: center;
  border: 0.1em solid colors.$border-subtle;
  border-radius: variables.$border-radius;
  font-size: font.$size-normal;

  &:focus-within {
    border-color: colors.$border-focused;
  }

  &.unset {
    color: colors.$text-subtle;
  }

  &.error {
    color: colors.$destructive;
    border-color: colors.$destructive;
  }

  input {
    width: 1.2em;
    padding-left: 0;
    padding-right: 0;
    border: none;
  }

  div {
    margin-left: 0.2em;
  }
}
</style>
